import { useState } from "react";
import "./App.css";
import Data from "./csvjson.json";
import DrugCard from "./Component/DrugCard/drugCard";

function App() {
  const [searchTerm, setSearchTerm] = useState("");

  let filteredData = Data;
  if (searchTerm) {
    filteredData = filteredData.filter(i =>
      i["Drug Name"].toLowerCase().includes(searchTerm.toLowerCase())
    );
  } else if (searchTerm === "") {
    filteredData = [];
  }

  console.log(filteredData);

  return (
    <div className="App">
      <div className="backgroundCircle"></div>
      <div className="contentContainers">
        <div className="leftContainer">
          <h1 className="header1">Doping Substances Database</h1>
          <div className="inputContainer">
            <input
              type="text"
              placeholder="Enter the drug name..."
              className="inputBox"
              onChange={e => setSearchTerm(e.target.value)}
            ></input>
          </div>
          <div className="btnContainer">
            <button>Search</button>
          </div>
        </div>
        <div className="rightContainer">
          <div className="glassCard">
            {filteredData.map(val => {
              return (
                <DrugCard
                  DrugName={val["Drug Name"]}
                  DrugClass={val["Drug Class"]}
                  WadaClass={val["Wada Class"]}
                  Status={val["Status"]}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
